<template>
    <div class="page">
        <div class="page__bd">
            <div class="form-preview weui-form-preview">
                <div class="weui-form-preview__hd">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">编号</label>
                        <em class="weui-form-preview__value">{{ form.jo_code }}</em>
                    </div>
                </div>
                <div class="weui-form-preview__bd">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">账户</label>
                        <span class="weui-form-preview__value">{{ form.jo_bkname }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">日期</label>
                        <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{ form.jo_date }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">币种</label>
                        <span class="weui-form-preview__value">{{ form.jo_currency }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_rate && form.jo_rate != 1">
                        <label class="weui-form-preview__label">汇率</label>
                        <span class="weui-form-preview__value">{{ form.jo_rate }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">摘要</label>
                        <span class="weui-form-preview__value">{{ form.jo_explanation }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_doubledebit">
                        <label class="weui-form-preview__label">原币收入</label>
                        <span class="weui-form-preview__value">{{ numberFormat(form.jo_doubledebit, '#,##0.##')
                            }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_doublecredit">
                        <label class="weui-form-preview__label">原币支出</label>
                        <span class="weui-form-preview__value">{{ numberFormat(form.jo_doublecredit, '#,##0.##')
                            }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_cmcurrency">
                        <label class="weui-form-preview__label">冲账币种</label>
                        <span class="weui-form-preview__value">{{ form.jo_cmcurrency }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_cmamount">
                        <label class="weui-form-preview__label">冲账金额</label>
                        <span class="weui-form-preview__value">{{ numberFormat(form.jo_cmamount, '#,##0.##') }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_cmrate && form.jo_cmrate != 1">
                        <label class="weui-form-preview__label">冲账汇率</label>
                        <span class="weui-form-preview__value">{{ form.jo_cmrate }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_poundage">
                        <label class="weui-form-preview__label">手续费</label>
                        <span class="weui-form-preview__value">{{ numberFormat(form.jo_poundage, '#,##0.##') }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_feecatename">
                        <label class="weui-form-preview__label">手续费科目</label>
                        <span class="weui-form-preview__value">{{ form.jo_feecatename }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_deptname">
                        <label class="weui-form-preview__label">部门</label>
                        <span class="weui-form-preview__value">{{ form.jo_deptname }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_seller">
                        <label class="weui-form-preview__label">业务员</label>
                        <span class="weui-form-preview__value">{{ form.jo_seller }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_othbkname">
                        <label class="weui-form-preview__label">转存账户</label>
                        <span class="weui-form-preview__value">{{ form.jo_othbkname }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_othamount">
                        <label class="weui-form-preview__label">转存金额</label>
                        <span class="weui-form-preview__value">{{ numberFormat(form.jo_othamount, '#,##0.##') }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_othcurrency">
                        <label class="weui-form-preview__label">转存币种</label>
                        <span class="weui-form-preview__value">{{ form.jo_othcurrency }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_othrate && form.jo_othrate != 1">
                        <label class="weui-form-preview__label">转存汇率</label>
                        <span class="weui-form-preview__value">{{ form.jo_othrate }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_othcaname">
                        <label class="weui-form-preview__label">对方科目</label>
                        <span class="weui-form-preview__value">{{ form.jo_othcaname }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_custname">
                        <label class="weui-form-preview__label">客户</label>
                        <span class="weui-form-preview__value">{{ form.jo_custname }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_vendname">
                        <label class="weui-form-preview__label">供应商</label>
                        <span class="weui-form-preview__value">{{ form.jo_vendname }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_vendbkinfo">
                        <label class="weui-form-preview__label">付款信息</label>
                        <span class="weui-form-preview__value">{{ form.jo_vendbkinfo }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_remark">
                        <label class="weui-form-preview__label">备注</label>
                        <span class="weui-form-preview__value">{{ form.jo_remark }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_vocode">
                        <label class="weui-form-preview__label">凭证</label>
                        <span class="weui-form-preview__value">{{ form.jo_vocode }}</span>
                    </div>
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">录入人</label>
                        <span class="weui-form-preview__value">{{ form.creatorName }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_source">
                        <label class="weui-form-preview__label">来源类型</label>
                        <span class="weui-form-preview__value">{{ form.jo_source }}</span>
                    </div>
                    <div class="weui-form-preview__item" v-if="form.jo_sourcecode">
                        <label class="weui-form-preview__label">来源单号</label>
                        <span class="weui-form-preview__value">{{ form.jo_sourcecode }}</span>
                    </div>
                </div>
            </div>
            <file-list v-model="form.jo_attach" />
        </div>
    </div>
</template>

<script>
import FileList from "@/components/FileList.vue";
import form from "@/mixins/form.js";

export default {
    mixins: [form],
    components: {
        FileList
    },
    data() {
        return {
            baseUrl: "/api/finance/journal"
        };
    }
};
</script>